import doublet from 'doublet';
import { Linking } from 'react-native';

export async function safelyOpenURL(url?: string) {
  if (url) {
    const byPassCan = url.startsWith('http') || url.startsWith('https');
    const [canError, can] = await doublet(() => Linking.canOpenURL(url));
    if (canError) {
      console.warn('safelyOpenURL: canOpenURL failed', canError);
      return;
    }

    if (byPassCan) {
      const [openError] = await doublet(() => Linking.openURL(url));
      if (openError) console.warn('safelyOpenURL: openURL failed', openError);
      return;
    }

    if (can) {
      const [openError] = await doublet(() => Linking.openURL(url));
      if (openError) console.warn('safelyOpenURL: openURL failed', openError);
    }
  }
}
